import { createSlice } from '@reduxjs/toolkit';

const updateUserInfo = createSlice({
  name: 'updateUserInfo',
  initialState: {
    user: {},
    pending: false,
    success: false,
    error: false,
  },
  reducers: {
    updateUserInfoStart: (state) => {
      state.pending = true;
      state.error = false;
    },
    updateUserInfoSuccess: (state, action) => {
      state.user = action.payload;
      state.success = true;
      state.pending = false;
      state.error = false;
    },
    updateUserInfoError: (state) => {
      state.success = false;
      state.pending = false;
      state.error = true;
    },
    resetupdateUserInfo: (state) => {
      state.success = false;
    },
  },
});
export const {
  updateUserInfoError,
  updateUserInfoStart,
  updateUserInfoSuccess,
  resetupdateUserInfo,
} = updateUserInfo.actions;
const updateUserInfoReducer = updateUserInfo.reducer;
export default updateUserInfoReducer;
